module.exports = __webpack_public_path__ + "static/media/ale-baja-logo-white.0ade3656.svg";